//package imports
import React, { useEffect, useState, } from "react";
import { useRouteMatch, useHistory,Redirect,Route,useLocation,Switch } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { removeData,getData } from "../../utils/AsyncStorage";
import { UserDetails,getNotificationDetails } from "../../services/apiServices/GetServices";
import { notificationViewApi,userDetailsApi} from "../../services/apiServices/PostServices";

//component imports
import CustomModal from "../../utils/resuableComponents/CustomModal";
import ClientDashboard from "./ClientDashboard";
import BuyShares from "./BuyShares";
import Profile from "./Profile";
import Support from "./Support";
import PromoCode from "./PromoCode";
import PrivateRoute from "../../router/PrivateRoute";
import PublicRoute from "../../router/PublicRoute";
import Sidemenu from "../sidebar/Sidemenu";
import SellShares from "./SellShares";
import MyShares from "./MyShares";
import PageNotFound from "../errorHandler/PageNotFound";

const ClientPanel = (props) => {
  const { path } = useRouteMatch();
  const [sidebarCollapse, setSidebarCollapse] = useState(false)
  const [showLogout, setShowLogout] = useState(false);
  const [userData,setUserData]=useState([])
  const [isEmailVerified,setIsEmailVerified]=useState([])
  const closeLogoutModal = () => setShowLogout(false)
  const [notifyModal,setNofityModal]=useState(false)
  const history = useHistory();
  const [notificationData,setNotification]=useState([])
  const [notifyData,setNotifyData]=useState("")
  const [notifyTime,setNotifyTime]=useState("")
  const [notificationCount,setNotificationCount]=useState(0)
  const termsAndCondtionPath = process.env.REACT_APP_TERMS_CONDTIONS
  const Privacy_Policy = process.env.React_App_Privacy_Policy
  const FAQ_Url = process.env.React_App_FAQ_Url
  const Contact_Us = process.env.React_App_Contact_Us  
  const pageNotFound = history?.location?.key === undefined
  const { role, first_name,last_name  } = JSON.parse(getData("userInfo") || 0);
  const date = new Date()
  const year = date.getFullYear()
  const userHasUpdatedProfile = (first_name === null)
  
  useEffect(() => {
    // Simulating an unauthorized scenario
    const isUnauthorized = role !== 3; // Replace with your actual authorization logic
    if (isUnauthorized) {
      // Navigate to the unauthorized page
      history.replace('/unauthorized');
    }
    callNotificationApi()
    
  }, [history]);

  useEffect(() => {
      // Check if the user has updated their profile
      if (userHasUpdatedProfile) {
        // If not, redirect to the create profile route
        history.push('/createProfile');
      }
    
  }, [history, userHasUpdatedProfile]);

  useEffect(() => {
   
    if(history?.location?.pathname === "/customerPortal/myShares"){
      handleUSerDetailsApi()
      callNotificationApi()
    }
  }, [history?.location?.pathname]);
 

//function call to handle userDetails
  const handleUSerDetailsApi = async() => {
    try{
      const res = await UserDetails(`user`);
      if (res?.success) {
          // setUserData(res?.data[0])
          setIsEmailVerified(res?.data[0]?.is_email_verified)
          const reqbody = {
            id: res?.data[0]?.id
        }
        if(res?.data[0]?.id!== ""){
          const res = await userDetailsApi(`userDetails`, reqbody);
        
          if (res?.success) {
            setUserData(res?.data[0])
        } else {
            // showToast(3, res?.message)
            console.log("res", res?.message)
        }
        }
       
      }else{
          console.log("res",res?.message)
         // showToast(3,res?.message)
      }
    }catch(error){
      console.log("error",error)
    }
    
}
  
  //function to handle profile navigation
  const handleItemProfile = (event) => {
    // Prevent the default behavior (e.g., page reload)
    event.preventDefault();
    history.push(
    {
      pathname :"/customerPortal/profile",
      state :{
      userDetails : userData,
      isEmailVerified: isEmailVerified
      }
      }
    )
    
  };

  const callNotificationApi = async() => {
    try{
      const res = await getNotificationDetails(`notifications`);

      if (res?.success) {
        setNotification(res?.notifications)
        setNotificationCount(res?.unread[0].notifications_count)
      }else{
          console.log("res",res?.message)
          //showToast(3,res?.message)
      }
    }catch(error){
      console.log("error",error)
    }
    
  }



  //function to handle logout 
  const handleItemLogout = (event) => {
    event.preventDefault();
    removeData("accessToken");
    removeData("userInfo")
    removeData("refresh_token")
    history.push("/login")
  }

  const handleLogoutModal = (event) => {
    event.preventDefault();
    setShowLogout(true)
  }

  const handleNotifyModalClose = () => {
    setNofityModal(false)
  }

  //function to call view notification api
  const handleViewNoficationApi = async (data) => {
    const reqBody = {
      id:data?.id
       }
       try{
        const res = await notificationViewApi("notifications",reqBody)
        if(res?.success){
         callNotificationApi()
        }else{
         console.log("res",res?.message)
        }
       }catch(error){
        console.log("error",error)
       }
  }

  //function to open notification view modal
  const handleOpenNotifyModal = (data) => {
    setNofityModal(true)
    setNotifyData(data?.message)
    handleViewNoficationApi(data)
    
  }

  const addOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return day + 'th';
    }

    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  //function call to format data and time 
  const handleFormatedDate = (date) => {
    const originalDate = new Date(date); // Replace this with your date object

    const options = { month: 'long', day: 'numeric', year: 'numeric' };
    let hours = originalDate.getHours() < 10 ? `0${originalDate.getHours()}` : `${originalDate.getHours()}`
    let minutes = originalDate.getMinutes() < 10 ? `0${originalDate.getMinutes()}` : `${originalDate.getMinutes()}` 
    const amPm = hours >= 12 ? 'PM' : 'AM';
    let dateMDY = `${hours}:${minutes}: ${amPm}`
    const formattedDate = originalDate.toLocaleDateString('en-US', options);
    const dayWithOrdinal = addOrdinalSuffix(originalDate.getDate());
    const finalFormattedDate = formattedDate.replace(originalDate.getDate(), dayWithOrdinal);

    let formatedDateTime = `${finalFormattedDate} ${dateMDY}`
    return formatedDateTime
  }



  const handleNotificationCard = (data) => {
       return(
        <div class="d-flex flex-column border-bottom ">
          <div class="d-flex flex-row">
          <div class="d-flex flex-column" onClick={() => handleOpenNotifyModal(data)}>
         <h6  class={data?.is_read === 0 ? "text-break fw-semi-bold roboto m-0" : "text-break fw-normal text-sm-start roboto status-pending m-0 "} >{data?.message}</h6>
         <h6 class={ data?.is_read === 0 ? "fw-normal m-0 mt-1"  : "fw-normal status-pending m-0 mt-2"}>{handleFormatedDate(data?.created)}</h6>
         </div>
         <div>
         <h6 class={data?.is_read === 0 ? "greenDot" : ""} ></h6>
         </div>
          </div>
        
        
        </div>
       
       )
  }

  return (
    <div class="container-fluid p-0">
      <div class="col-md-12 d-flex ">
        <Sidemenu
          collapse={sidebarCollapse}
          path={path}
        />

        <div class={sidebarCollapse ? "d-flex flex-column col-md-11 " : " d-flex flex-column col-md-10 "}>
          <nav class="navbar navbar-light navStyle p-0">
            <div class="mx-2" onClick={() => setSidebarCollapse(!sidebarCollapse)} >
              <i class="bi bi-list fs-2 text-white"></i>
            </div>
            <ul class="nav justify-content-center align-items-center ms-auto">
              <li class="nav-item mx-2">
                 <div>
                <Dropdown >
                  <Dropdown.Toggle id="dropdown-basic" variant="transparent" style={{border:0, color: "white",position:"relative"}}>
                  <span className={notificationCount !== 0  ? "redDot" : ""}></span>
                  <i class="bi bi-bell fs-4 text-white"  ></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ maxHeight: '400px', overflowY: 'auto' }} >
                  <h4 class="fw-bold mx-2 montserrat p-2">Notifications</h4>
                  
                    {  notificationData.length !== 0 ? 
                      notificationData.map((data) => {
                        return (
                          <div>
                          <Dropdown.Item href="" style={{ whiteSpace: 'normal',width:"600px" }} >{handleNotificationCard(data)}</Dropdown.Item>
                          </div>
                        )
                      }) 
                      :
                      <Dropdown.Item href="" style={{ whiteSpace: 'normal',width:"600px",textAlign:"center" }} >No Notifications</Dropdown.Item>
                    }
                  
                  </Dropdown.Menu>
                </Dropdown> 
      </div> 
              </li>
              <li class="nav-item mx-2">
                <h1 class="text-white fs-5 m-0">{first_name}</h1>
              </li>
              <li class="nav-item mx-2">
                <Dropdown >
                  <Dropdown.Toggle id="dropdown-basic" variant="transparent" style={{border:0, color: "white"}}>
                    <i class="bi bi-person-circle fs-2 text-white"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu >
                    <Dropdown.Item href="" onClick={handleItemProfile} >Profile</Dropdown.Item> 
                     <Dropdown.Item href="" onClick={handleLogoutModal} >Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
            </ul>

          </nav>

          {
            // pageNotFound  ?
            //  <PublicRoute component={PageNotFound} path="*" exact /> 
            // :  
            <div class="col-md-12">
              <Switch>
            <PrivateRoute
              restricted={true}
              component={ClientDashboard}
              path={`${path}/clientDashboard`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={Profile}
              path={`${path}/profile`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={Support}
              path={`${path}/support`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={PromoCode}
              path={`${path}/promoCode`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={MyShares}
              path={`${path}/myShares`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={BuyShares}
              path={`${path}/myShares/buyShares`}
              exact
            />
            <PrivateRoute
              restricted={true}
              component={SellShares}
              path={`${path}/myShares/sellShares`}
              exact
            />

             <PublicRoute component={PageNotFound} path="*" exact />
             </Switch>
          </div> 
          }

          <CustomModal 
                      close={closeLogoutModal}
                      open={showLogout}
                      Action={handleItemLogout}
                      modalContent = {"Are you sure you want to log out?"}
                     />
          
                   <CustomModal 
                      close={handleNotifyModalClose}
                      open={notifyModal}
                      modalTitle={notifyData}
                      notifytime={notifyTime}
                      imgvalue={"notify"}
                      from={"client"}
                     />

          <div class="d-flex justify-content-between align-items-center p-2 foaterBackgroundStyle col-md-12 mt-auto">
            <div class="mx-2">
              <p class="m-0 colorPrimary roboto">{`Copyrights@${year} Osan Grows`}</p>
            </div>
            <div class="d-flex mx-2 gap-4">
              <a href={Privacy_Policy} class="text-decoration-none colorPrimary roboto" target="_blank">Privacy Policy</a>
              <a href={termsAndCondtionPath} class="text-decoration-none colorPrimary roboto" target="_blank">Terms & Conditions</a>
              <a href={FAQ_Url} class="text-decoration-none colorPrimary roboto" target="_blank">FAQs</a>
              <a href={Contact_Us} class="text-decoration-none colorPrimary roboto" target="_blank">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClientPanel